export const LineTelegramIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.8452 10.7768L20.5179 21.7527C20.3421 22.5272 19.8844 22.72 19.2338 22.3554L15.6873 19.7421L13.9764 21.3881C13.7869 21.5776 13.6288 21.7357 13.2635 21.7357L13.5186 18.1242L20.0909 12.1853C20.3768 11.9308 20.0287 11.7893 19.6469 12.0443L11.5217 17.1607L8.02373 16.0656C7.26299 15.8282 7.24921 15.3049 8.18238 14.9397L21.8642 9.66845C22.4977 9.43102 23.0518 9.80892 22.8452 10.7768Z"
        fill="white"
      />
      <circle cx="16" cy="16" r="15.5" stroke="white" />
    </svg>
  );
};
